const PASSWORD = {
  FULL_PASSWORD:
    /^(?=(.*[a-z]))(?=(.*[A-Z]))(?=(.*\d))(?=(.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]))(?=.{8,}).*$/,
  AT_LEAST_8_CHARACTERS: /^(?=.{8,})/,
  AT_LEAST_ONE_LOWER_CASE_LETTER: /^(?=(.*[a-z]))/,
  AT_LEAST_ONE_UPPER_CASE_LETTER: /^(?=(.*[A-Z]))/,
  AT_LEAST_ONE_NUMBER: /^(?=(.*\d))/,
  AT_LEAST_ONE_SPECIAL_CHARACTER:
    /^(?=(.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]))/,
};

export const REGEXES = {
  PASSWORD,
};
